"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ActivityAsync;

var _AsyncComponent = _interopRequireDefault(require("customer-data-ui-utilities/component/AsyncComponent"));

var _react = _interopRequireDefault(require("react"));

var _UILoadingDots = _interopRequireDefault(require("UIComponents/loading/UILoadingDots"));

var _AsyncComponentErrorHandler = _interopRequireDefault(require("crm_ui/utils/AsyncComponentErrorHandler"));

function requirement(done) {
  import(
  /* webpackChunkName: "communicator-secondary-Activity" */
  './Activity').then(function (mod) {
    return mod.default;
  }).then(done, (0, _AsyncComponentErrorHandler.default)('communicator-secondary'));
}

function ActivityAsync(props) {
  return _react.default.createElement(_AsyncComponent.default, {
    loadingContent: _react.default.createElement(_UILoadingDots.default, {
      minHeight: 200
    }),
    props: props,
    requirement: requirement
  });
}

module.exports = exports.default;